export default __webpack_public_path__ + "static/media/DNo.1-1.7d11d179.jpg";